var jQuery = $;
import slick from '../../node_modules/slick-carousel/slick/slick.min.js';
import para from '../../node_modules/jquery-parallax.js/parallax.min.js';
import fancy from '../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js';
const app = {
    /**
     * Initialize.
     */
    init() {

        // Smooth scroll to Anchor
        this.smoothAnchor();

        // Initialize sliders
        this.initSliders();

        //Active news CPT
        this.CptNewsActive();

        // Register our event listeners
        $(window).on('scroll', $.proxy(this.windowScrollHandler, this));
        $('.hamburger, .navigation-overlay').on('click', $.proxy(this.toggleHamburgerMenu, this));
    },
    
    /** Handles the scroll event. */
    windowScrollHandler() {
        $('header').toggleClass('scrolled', $(window).scrollTop() > 0);
    },
    
    /** Open hamburger menu. */
    toggleHamburgerMenu() {
        $(".hamburger").toggleClass('is-active');
        $("nav.navigation").toggleClass('visible');
        $(".navigation-overlay").toggleClass('is-active');
        $("body").toggleClass('is-locked');
    },

    /** Smooth scroll to Anchor */
    smoothAnchor() {
        $(document).on('click', 'main a[href^="#"]', function(e) {
            let id = $(this).attr('href');
            let $id = $(id);
            if ($id.length === 0) {
                return;
            }
            e.preventDefault();
            let pos = $id.offset().top - 60;
            $('body, html').animate({scrollTop: pos});
        });
    },

    /** Init sliders */
    initSliders() {

        if ($('.slider').length) {
            $('.slider').slick({
                fade: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 3500,
                arrows: true,
                dots: false,
                nextArrow: '.image .arrow.arrow-next',
                prevArrow: '.image .arrow.arrow-prev',
            });
        }

        if ($('.slider-large').length) {
            $('.slider-large').slick({
                fade: false,
                infinite: true,
                slidesToShow: 4,
                slidesToScroll: 2,
                autoplay: true,
                autoplaySpeed: 3500,
                arrows: true,
                dots: false,
                nextArrow: '.full-slider .arrow.arrow-next',
                prevArrow: '.full-slider .arrow.arrow-prev',
                responsive: [
                    {breakpoint: 480, settings: {slidesToShow: 1}},
                    {breakpoint: 768, settings: {slidesToShow: 2}},
                    {breakpoint: 1025, settings: {slidesToShow: 3}},
                ]
            });
        }
    },

    CptNewsActive() {
        var loc = window.location.href; // returns the full URL
        if(/blog/.test(loc)) {
            $('ul.navigation-list a[href*="/nieuws/"]').addClass('active');
        }
    },
};

$(document).ready($.proxy(app.init, app));
